import { integrations } from '@/app/[locale]/womens-health/_data/womensHealthIntegrations';
import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

const WomensHealthIntegrations = () => {
  return (
    <section className="py-16" data-cy="womens-health-integrations">
      <LandingPageIntegrations
        description="womens_integrations_copy"
        logoColor="black"
        integrations={integrations}
        title="pop_integrations_title"
      />
    </section>
  );
};

export default WomensHealthIntegrations;
